/**
 * Maps a Route (plus the resolved plugin, when on a detail/edit page) to a
 * human-meaningful document title. Kept separate from App.tsx so the mapping is
 * unit-testable without the full component/auth/env dependency graph, mirroring
 * routing.ts. Distinct titles let Google Analytics distinguish page visits that
 * previously all reported the static "AI Marketplace" title.
 */

import type { Route } from "./routing";
import type { MarketplaceEntry } from "../types/index";

export const BASE_TITLE = "AI Marketplace";

export function resolvePageTitle(route: Route, plugin?: MarketplaceEntry | null): string {
  switch (route.page) {
    case "catalog":
      return BASE_TITLE;
    case "detail":
      return plugin ? `${BASE_TITLE} - ${plugin.pluginName}` : `${BASE_TITLE} - Not Found`;
    case "edit":
      return plugin ? `${BASE_TITLE} - Edit ${plugin.pluginName}` : `${BASE_TITLE} - Edit`;
    case "contribute":
      return `${BASE_TITLE} - Contribute a Skill`;
    case "help":
      return `${BASE_TITLE} - Help`;
    case "admin":
      return `${BASE_TITLE} - Admin`;
  }
}
